const translations = {
  invalidEmail: 'Email is invalid.',
  invalidPassword: 'Password is invalid.',
  passwordsDoNotMatch: 'Passwords do not match.',
};

export default translations;
